import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text, SimpleFlexbox, getSimpleLabel } from 'ctm-components';
import { get, pageContext, getRulesFromState, haveRulesChanged } from 'ctm-util-functions';

import styles from './excess_amount.css';

class _ExcessAmount extends Component {

    /**
     * Don't re-render unless rules have changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render, false otherwise
     */
    shouldComponentUpdate = (nextProps, nextState) => {
        return haveRulesChanged(nextProps, this.props);
    };

    /**
     * Render the Excess Amount if it should be visible
     * @returns {Node|Null} - The excess amount if it should be visible
     */
    render = () => {
        if (!get(this.props, 'rules.visibility.result', true)) {
            return null;
        }

        const { elementProps, contentProps, visualProps, stateProps } = this.props;
        const label = getSimpleLabel(contentProps);
        const showLabels = pageContext.getProps().pageState.breakpoint !== 'xs';
        const dataId = label ? `${label.toLowerCase()}-excess-price` : null;

        const homeExcessAmount = stateProps ? JSON.parse(JSON.stringify(stateProps)).product.productMeta.homeExcess.amount : {};
        const homeExcessStateKey = contentProps ? JSON.parse(JSON.stringify(contentProps)).stateKey : null;
        const homeExcessElementProps = elementProps ? JSON.parse(JSON.stringify(elementProps)).tagName : {};
        return (
            <div className={styles.root}>
                <SimpleFlexbox display="flex" itemCenter="xs">
                    <Text
                        className={
                            (homeExcessAmount === '0' && (dataId === 'building-excess-price' || dataId === 'home-excess-price'))
                            // eslint-disable-next-line max-len
                            // Hacky change to not display labels and values if homeExcessAmount is 0 ticket: https://dev.azure.com/ctmaus/CTM/_sprints/backlog/GI%20Team/CTM/Sprint%2047?workitem=21552
                            || (homeExcessAmount === '0' && dataId === null && homeExcessStateKey === 'product.productMeta.homeExcess.amount' && homeExcessElementProps === 'strong')
                                ? styles.hide
                                : styles.show
                        }
                        dataId={dataId}
                        stateProps={stateProps}
                        {...elementProps}
                        {...contentProps}
                        {...visualProps}
                    />
                    <div
                        className={`${styles.label} ${
                            homeExcessAmount === '0' && (dataId === 'building-excess-price' || dataId === 'home-excess-price') ? styles.hide : styles.show
                        }`}
                    >
                        <Text label={label} size="small" />
                    </div>
                </SimpleFlexbox>
            </div>
        );
    };

}

_ExcessAmount.propTypes = {
    elementProps: PropTypes.object,
    contentProps: PropTypes.object,
    visualProps: PropTypes.object,
    stateProps: PropTypes.object,
    // eslint-disable-next-line react/no-unused-prop-types
    rules: PropTypes.object
};

/**
 * Map the rules to the props
 * @param {Object} state - The application state
 * @param {Object} props - The component props
 * @returns {Object} - The resolved rules object
 */
const mapStateToProps = (state, props) => {
    const rules = props.rules ? getRulesFromState(state, props) : null;
    return {
        rules
    };
};

export const ExcessAmount = connect(mapStateToProps)(_ExcessAmount);
export { _ExcessAmount };
